<template>
  <v-sheet
    class="control-panel"
    elevation="0"
  >
    <div class="control-panel__langs">
      <LanguageSwitcher />
      <PreviewDemoBtn />
    </div>

    <h1 class="control-panel__title">{{ $t('control.panel.title') }}</h1>

    <div class="control-panel__line">
      <BotId />
    </div>

    <div class="control-panel__line">
      <TimeoutMode />
    </div>

    <div class="control-panel__line">
      <RecognizeUserMetaMode />
    </div>

    <div class="control-panel__line">
      <DisplayMode />
    </div>

    <div 
      class="control-panel__line"
      v-if="!isDisplayMode('frame')"
    >
      <WidgetTheme />
    </div>

    <div class="control-panel__line">
      <WidgetTitle />
    </div>

    <div class="control-panel__line">
      <WidgetImages />
    </div>

    <div
      v-if="isDisplayMode('widget')"
      class="control-panel__line"
    >
      <ButtonMode />
    </div>

    <div
      class="control-panel__line"
      v-if="isButtonMode('button')"
    >
      <WidgetButtonAnimationMode />
    </div>

    <div
      v-if="isButtonMode('multi')"
      class="control-panel__line"
    >
      <MultiChannel />
    </div>

    <div
      v-if="isDisplayMode('widget') && (isButtonMode('button') || isButtonMode('bar') || isButtonMode('multi'))"
      class="control-panel__line"
    >
      <IconMode />
    </div>

    <div
      v-if="isDisplayMode('widget') && isButtonMode('avatar')"
      class="control-panel__line"
    >
      <AvatarPose />
    </div>

    <div
      v-if="isDisplayMode('widget') && isButtonMode('avatar')"
      class="control-panel__line"
    >
      <AvatarScale />
    </div>

    <div class="control-panel__line">
      <CustomEvent />
    </div>

    <div class="control-panel__line">
      <Demonstrate />
    </div>
  </v-sheet>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

import LanguageSwitcher from './LanguageSwitcher.vue';
import DisplayMode from './ControlUnit/DisplayMode.vue';
import WidgetTheme from './ControlUnit/WidgetTheme.vue';
import WidgetTitle from './ControlUnit/WidgetTitle.vue';
import WidgetImages from './ControlUnit/WidgetImages.vue';
import ButtonMode from './ControlUnit/ButtonMode.vue';
import IconMode from './ControlUnit/IconMode.vue';
import AvatarPose from './ControlUnit/AvatarPose.vue';
import AvatarScale from './ControlUnit/AvatarScale.vue';
import CustomEvent from './ControlUnit/CustomEvent.vue';
import Demonstrate from './ControlUnit/Demonstrate.vue';
import BotId from './ControlUnit/BotId.vue';
import MultiChannel from './ControlUnit/MultiChannel.vue';
import TimeoutMode from "./ControlUnit/TimeoutMode.vue";
import PreviewDemoBtn from "./ControlUnit/PreviewDemoBtn.vue";
import RecognizeUserMetaMode from "./ControlUnit/RecognizeUserMetaMode.vue";
import WidgetButtonAnimationMode from "@/views/Control/ControlPanel/ControlUnit/WidgetButtonAnimationMode.vue";

export default {
  components: {
    LanguageSwitcher,
    DisplayMode,
    WidgetTheme,
    WidgetTitle,
    WidgetImages,
    ButtonMode,
    IconMode,
    AvatarPose,
    AvatarScale,
    CustomEvent,
    Demonstrate,
    BotId,
    MultiChannel,
    TimeoutMode,
    PreviewDemoBtn,
    RecognizeUserMetaMode,
    WidgetButtonAnimationMode,
  },
  setup() {
    const store = useStore();

    const isDisplayMode = computed(() => {
      return store.getters['control/isDisplayMode'];
    });

    const isButtonMode = computed(() => {
      return store.getters['control/isButtonMode'];
    });

    return {
      isDisplayMode,
      isButtonMode,
    };
  },
};
</script>

<style lang="scss">
.control-panel {
  $this: 'control-panel';

  &__langs {
    margin-bottom: 20px;
  }

  &__title {
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 25px;
  }

  &__line {
    &:not(:last-child) {
      margin-bottom: 30px;
    }
  }

  &__btn {
    margin-right: 5px;
    margin-top: 5px;
  }
}
</style>
